module.exports = __webpack_public_path__ + "img/3.c8e78218.png";